var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Dashboard_1;
import React, { Component } from 'react';
import { LayoutGap } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, element, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { classNames, enumValues, getLostProps, propagateProps } from '@philips-internal/oswald-ui-utils';
import { DashboardAPI } from './dashboard-api.js';
import './dashboard.css';
const DashboardContainer = {
    acceptedTypes: [
        ComponentType.BEHAVIOR,
        ComponentType.DATA_DISPLAY,
        ComponentType.LIST,
    ],
    name: '',
};
let Dashboard = Dashboard_1 = class Dashboard extends Component {
    getClassName() {
        const { className } = this.props;
        return classNames({
            'c-dashboard': true,
            'u-expand': true,
            [`${className}`]: Boolean(className),
        });
    }
    getStyle() {
        const { rowGap = Dashboard_1.defaultProps.rowGap, columnGap = Dashboard_1.defaultProps.columnGap, } = this.props;
        return {
            columnGap,
            rowGap,
        };
    }
    renderContent() {
        const { children } = this.props;
        const lostProps = getLostProps(Dashboard_1.propTypes, this.props);
        return propagateProps(children, lostProps);
    }
    render() {
        const { uuid } = this.props;
        return (React.createElement(Container, { acceptedTypes: DashboardContainer.acceptedTypes, className: this.getClassName(), style: this.getStyle(), uuid: uuid }, this.renderContent()));
    }
};
Dashboard.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    columnGap: oneOf(enumValues(LayoutGap)).group('layout'),
    rowGap: oneOf(enumValues(LayoutGap)).group('layout'),
    uuid: string,
};
Dashboard.defaultProps = {
    columnGap: LayoutGap.LARGE,
    rowGap: LayoutGap.LARGE,
};
Dashboard = Dashboard_1 = __decorate([
    AwesomeComponent({ api: DashboardAPI, containers: [DashboardContainer], type: ComponentType.LIST })
], Dashboard);
export { Dashboard, };
export default Dashboard;
//# sourceMappingURL=dashboard.js.map